import FileDownload from "js-file-download";

function escapeCsvValue(value) {
  if (value === null || value === undefined) return "";
  const str = String(value);
  // Escape double quotes by doubling them. Wrap in quotes if needed.
  const needsQuotes = /[\n\r,\"]/g.test(str);
  const escaped = str.replace(/\"/g, '""');
  return needsQuotes ? `"${escaped}"` : escaped;
}

function getCellValue(row, column) {
  if (!column) return "";

  if (typeof column.value === "function") {
    return column.value(row);
  }

  const key = column.key;
  if (!key) return "";

  return row?.[key];
}

/**
 * @param {Object} params
 * @param {Array<Object>} params.rows
 * @param {Array<{header: string, key?: string, value?: (row:any)=>any}>} params.columns
 * @param {string} params.filename
 */
export function exportToCsv({ rows, columns, filename }) {
  const safeRows = Array.isArray(rows) ? rows : [];
  const safeColumns = Array.isArray(columns) ? columns : [];

  const headerLine = safeColumns.map((c) => escapeCsvValue(c.header)).join(",");
  const dataLines = safeRows.map((row) =>
    safeColumns.map((c) => escapeCsvValue(getCellValue(row, c))).join(",")
  );

  const csv = [headerLine, ...dataLines].join("\r\n");

  // Add UTF-8 BOM so Excel opens it correctly.
  const withBom = "\uFEFF" + csv;
  FileDownload(withBom, filename || "export.csv");
}
